module.exports = __webpack_public_path__ + "img/alipay.83981b64.png";